/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) { window.boostSDAppConfig.integration = Object.assign({ wishlists: 'plus' }, window.boostSDAppConfig.integration || {}); }

/* Boost - 224005 */
const isiOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}
window.addEventListener("pageshow", function (evt) {
    if (evt.persisted && isiOS()) {
        location.reload();
    }
}, false);
/* Boost - 224005 */
const customize = {
    updateProductItem: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Modify Product Item HTML',
            enabled: true,
            apply: () => ({
                beforeInit(element) {
                },
                afterInit(element) {
                },
                render(elementModel, currentRenderElement) {
                    return currentRenderElement;
                },
                beforeRender(element) {
                },
                afterRender(element) {
                    // use pure JS here
                    let productData = element.getParams().props.product;
                    let productItem = document.querySelector('.boost-sd__product-item[data-product-id="' + productData.id + '"]');
                    buildProductsLinked(productItem, productData)
                    buildSwatch(productItem, productData)
                    buildWishList(productItem, productData)
                    buildBISLabel(productItem, productData)
                    buildCollectionLabel(productItem, productData)

                }
            }),
        });
    },
    // Boost - 224005
    scrollBack: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductList', {
            name: 'keep position after back from pdp',
            enabled: true,
            apply: () => ({
                props: (props) => {
                    props.disableDeferredRender = false;
                    props.afterRender = () => {
                    };
                    return props;
                }
            })
        });
    },
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem, customize.scrollBack]);
const buildCollectionLabel = (element, data) => {
    let html = ''
    const collectionLabels = window.collectionLabels
    const labelContainer = element.querySelector('.boost-sd__product-image-column.boost-sd__product-image-column--in-top')
    data.collections.forEach((collection) => {
        collectionLabels.forEach((item) => {
            if (collection.title === item.collection) {
                html += `<div style="background-color: ${item.color_background};color:${item.color_text}" class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__product-label--soldout">
                <span class="boost-sd__product-label-text">
                       ${item.text}
                </span>
            </div>`
            }
        })
    })
    if(labelContainer && !labelContainer.classList.contains('label-added')){
        labelContainer.innerHTML += html
        labelContainer.classList.add('label-added')
    }
}
const buildBISLabel = (element, data) => {
    const isBISCollection = data.collections.some(item => item.title === 'Back In Stock')
    const hasOutStock = data.variants.some(item => !item.available)
    if (isBISCollection) {
        const labelEl = element.querySelector('.boost-sd__product-label--soldout .boost-sd__product-label-text')
        const labelContainer = element.querySelector('.boost-sd__product-image-column.boost-sd__product-image-column--in-top')
        if (labelEl) {
            labelEl.innerHTML = 'Back In Stock'
        } else {
            labelContainer.innerHTML += `<div style="background-color: #000" class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__product-label--soldout">
                <span class="boost-sd__product-label-text">
               Back In Stock
                </span>
            </div>`
        }
    } else {
        if ((data.tags.includes('bis') || data.tags.includes('BIS')) && hasOutStock) {
            const labelEl = element.querySelector('.boost-sd__product-label--soldout .boost-sd__product-label-text')
            const labelContainer = element.querySelector('.boost-sd__product-image-column.boost-sd__product-image-column--in-top')
            if (labelEl) {
                labelEl.innerHTML = 'RESTOCK COMING'
            } else {
                labelContainer.innerHTML += `<div style="background-color: #000" class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__product-label--soldout">
                <span class="boost-sd__product-label-text">
                RESTOCK COMING
                </span>
            </div>`
            }
        }
    }

}
const buildWishList = (element, data) => {
    const elWishlist = element.querySelector('status-save-button')
    if(!elWishlist) return
    const html = `<status-save-button product-id="${data.id}" icon="heart">
  </status-save-button>`
    const imageEl = element.querySelector('.boost-sd__product-item-grid-view-layout-image')
    imageEl.insertAdjacentHTML('beforebegin', html)
}
const buildSwatch = (element, data) => {
    let swatchHTML = ''
    if (!data.variants.length > 0 || !data.available) return false
    const infoEl = element.querySelector('.boost-sd__product-info')
    if (element.querySelector('.swatch-list')) return false
    if (data.variants.length === 1 && data.variants[0].title === 'Default Title' && data.available) {
        swatchHTML += `<div class="swatch-list">`
        swatchHTML += `<div class="variant-swatch btn btn--primary"  data-id="${data.variants[0].id}">Add To Cart</div>`
        swatchHTML += `</div>`
    } else {
        swatchHTML += `<ul class="swatch-list">`
        data.variants.forEach((variant) => {
            swatchHTML += `<li class="${variant.available ? '' : 'disabled'} variant-swatch" data-id="${variant.id}">${variant.title}</li>`
        })
        swatchHTML += `</ul>`
    }
    const reviewEl = element.querySelector('.boost-sd__integration-product-rating')
    if (reviewEl) reviewEl.insertAdjacentHTML('beforebegin', swatchHTML)
    const swatchEl = element.querySelector('.swatch-list')
    if (swatchEl) addToCartSwatch(swatchEl,data)

}

const addToCartSwatch = (element,data) => {
    const swatchBtns = element.querySelectorAll('.variant-swatch:not(.disabled)')
    swatchBtns.forEach((swatch) => {
        swatch.addEventListener('click', (e) => {
            e.preventDefault()
            const id = swatch.getAttribute('data-id')
            addProductToCart(id,1,data)
            swatch.classList.add('loading')
            setTimeout(() => {
                swatch.classList.remove('loading')
            }, 1500)
        })
    })
}

const addProductToCart = (id, qty = 1,data) => {
    const variant = data.variants.find(v => v.id == id)
    const item = {
        "Name": data.title,
        "ProductID": data.id,
        "Categories": data.collections.map(c => c.title),
        "ImageURL": data.images[0] || data.images[1],
        "URL": `${window.location.origin}/products/${data.handle}`,
        "Brand": data.vendor,
        "Price": `$${variant.price}`,
        "Value": variant.price,
        "CompareAtPrice": `$${variant.compare_at_price}`
    }
    console.log(item)
    let formData = {
        'items': [{
            'id': id,
            'quantity': qty
        }]
    };
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            window.cart.getCart(item)
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useModulePlugin('CartAPI', {
            name: 'Integrate theme cart',
            apply(builder) {
                builder.on('methodFulfilled', 'addToCart', async (payload) => {
                    window.cart.getCart()
                    return payload;
                });
            },
        });

    }
]);
const buildProductsLinked = async (element, data) => {
    if(!data.metafields.some(item => item?.key === 'products_linked')){
        return ''
    }

    const metafield = data.metafields.find(item => item?.key === 'products_linked')
    const fetchproductsLinked = await getProductsLinked(metafield?.value)
    const productsLinked = fetchproductsLinked.filter(item => item != null)
    const currentProduct = await getCurrentProduct(data.handle)
    if(element.querySelector('.product__card-products_linked')) return ''
    let productsLinkedHTML = ''

    if(!productsLinked) return ''
    productsLinkedHTML += '<ul class="product__card-products_linked">'
    if(currentProduct){
        const currentSwatchImage = currentProduct.metafields.find(item => item && item?.key && item?.key === 'image')?.reference?.image?.originalSrc
        const currentSwatchTitle = currentProduct.metafields.find(item => item && item?.key && item?.key === 'title')?.value
        const currentFeaturedImage = currentProduct.images?.nodes?.find(Boolean).url
        productsLinkedHTML += `
        <li class="product__card-product_linked" data-title="${currentSwatchTitle}" data-image="${currentFeaturedImage}" data-title="${currentSwatchTitle}"><a href="/products/${currentProduct.handle}"><img src="${currentSwatchImage}" alt="${currentSwatchTitle}"></a></li>
        `
    }
    if(productsLinked.length < 5) {
        productsLinked.forEach((product) => {
            const metafields = product?.metafields
            if(metafields) {
                const image = metafields.find(item => item && item?.key && item?.key === 'image') ? metafields.find(item => item?.key === 'image').reference?.image.originalSrc : ''
                const title = metafields.find(item => item && item?.key && item?.key === 'title')?.value
                productsLinkedHTML += `
        <li class="product__card-product_linked" data-title="${title}" data-title="${title}"><a href="/products/${product.handle}"><img src="${image}" alt=""></a></li>
        `
                const imageEl = element.querySelector('.boost-sd__product-image')
                imageEl.innerHTML += `<img data-title="${title}" class="boost-sd__product-image-img boost-sd__product-image-img--second boost-sd__product-image-linked" src="${product.featuredImage.originalSrc}"/>`
            }
        })
        productsLinkedHTML += '</ul>'
    }else {
        const number = productsLinked.length - 4
        productsLinked.slice(0, 4).forEach((product) => {
            const metafields = product.metafields
            const image = metafields.find(item => item?.key === 'image')?.reference?.image.originalSrc
            const title = metafields.find(item => item?.key === 'title')?.value
            productsLinkedHTML += `
        <li class="product__card-product_linked" data-title="${title}" data-title="${title}"><a href="/products/${product.handle}"><img src="${image}" alt=""></a></li>
        `
            const imageEl = element.querySelector('.boost-sd__product-image')
            imageEl.innerHTML += `<img data-title="${title}" class="boost-sd__product-image-img boost-sd__product-image-img--second boost-sd__product-image-linked" src="${product.featuredImage.originalSrc}"/>`
        })
        productsLinkedHTML += `<li class="product__card-product_linked-number">+${number}</li>`
        productsLinkedHTML += '</ul>'
    }


    const priceEl = element.querySelector('.boost-sd__product-price')
    if (priceEl) priceEl.insertAdjacentHTML('afterend', productsLinkedHTML)
    element.querySelectorAll('.product__card-product_linked').forEach((el)=>{
        handleHoverSwatch(element,el)
    })
}
const handleHoverSwatch = (container,el) => {
    const imageEls = container.querySelectorAll(`.boost-sd__product-image-linked`)
    el.addEventListener('mouseover', () =>{
        const title = el.getAttribute('data-title')
        const imageEl = container.querySelector(`.boost-sd__product-image-linked[data-title="${title}"]`)
        imageEls.forEach(el => el.classList.remove('active'))
        imageEl?.classList.add('active')
    })
    el.addEventListener('mouseleave', () =>{
        imageEls.forEach(el => el.classList.remove('active'))
    })
}
const getCurrentProduct = async (handle) => {
    if (!handle) return ''
    const param = `{
          productByHandle(handle: "${handle}") {
            id
            title
            handle
            images(first: 1) {
             nodes {
              url
              altText
             }
            }
            metafields(identifiers: [{namespace: "swatch", key: "image"},{namespace: "swatch", key: "title"}]) {
                namespace
                key
                value
                reference {
                  ... on MediaImage {
                      image {
                       originalSrc
                    }
                  }
                }
            }
          }
        }`
    const response = await executeGraphQlQuery({query: param})
        .then(res => {
            return res.json()
        }).then(data => {
            if (data.errors) {
                throw data
            }
            return data.data
        }).catch(error => {
            console.warn('error', error)
            return null
        })
    return response?.productByHandle
}
const getProductsLinked = async (productsLinked) => {
    if (!productsLinked) return ''
    const param = `{
          nodes(ids: ${productsLinked}) {
            ... on Product {
              id
              title
              handle
              featuredImage {
                originalSrc
                altText
              }
              metafields(identifiers: [{namespace: "swatch", key: "image"},{namespace: "swatch", key: "title"}]) {
                namespace
                key
                value
                reference {
                  ... on MediaImage {
                      image {
                       originalSrc
                    }
                  }
                }
              }
            }
          }
        }`
    const response = await executeGraphQlQuery({query: param})
        .then(res => {
            return res.json()
        }).then(data => {
            if (data.errors) {
                throw data
            }
            return data.data
        }).catch(error => {
            console.warn('error', error)
            return null
        })
    return response?.nodes
}
/**
 * @returns { {
 *    'Content-Type': 'application/json',
 *    Accept: 'application/json',
 *    'X-Shopify-Storefront-Access-Token': string
 * } }
 */
function getGraphQlHeaders () {
    return {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Storefront-Access-Token': '7ffce8cf4b5c304fc0a424e0f703546a'
    }
}

/**
 * Returns graphql request with no callback
 * @param { {
 *  query: string
 *  variables?: unknown
 * } } param0
 * @returns { fetch }
 */
function executeGraphQlQuery ({ query, variables }) {
    const url = `https://${ Shopify.shop }/api/2023-10/graphql.json`

    // remove line breaks and double space for legibility
    const cleanQuery = query.replace(/\n/g, ' ').replace(/ {2}/g, '')

    const config = {
        method: 'post',
        headers: getGraphQlHeaders(),
        body: JSON.stringify({
            query: cleanQuery,
            // only add variables if they actually exist
            ...(variables ? { variables } : {})
        })
    }

    return fetch(url, config)
}


const customize_inline_banner = {
    productListAfterRender: (componentRegistry) => {
        let preventReCallProductHandlesTheSame = [];
        componentRegistry.useComponentPlugin('ProductList', {
            name: 'Product List After Render',
            enabled: true,
            apply: () => ({
                afterRender(element) {

                    try {
                        const helpersRef = element.getHelpers();
                        // Function get all handles displayed in product list
                        const productHandles = helpersRef.getProductHandles();
                        // Check duplicate not call. prevent call multi the same value
                        const isDuplicate = JSON.stringify(preventReCallProductHandlesTheSame) === JSON.stringify(productHandles);

                        const bannerEls = document.querySelectorAll('.boost-sd__product-inline_banner')
                        preventReCallProductHandlesTheSame = productHandles;
                        if(bannerEls.length > 0) {
                            bannerEls.forEach(el => {
                                el.remove()
                            })
                        }
                        setTimeout(() => {
                            if (productHandles?.length && !isDuplicate) {
                                const container = document.querySelector('.boost-sd__product-list')
                                const banners = window.bannerData

                                banners?.forEach(banner => {
                                    const index = parseInt(banner.position - 1)
                                    const existingDiv = container.children[index] || container.querySelectorAll('.boost-sd__product-item:not(.boost-sd__product-inline_banner)')[index];
                                    console.log(container.querySelectorAll('.boost-sd__product-item:not(.boost-sd__product-inline_banner)')[index])
                                    let cardHTML = ''
                                    cardHTML += `<div class="boost-sd__product-item boost-sd__product-inline_banner" >
                                                   <a href="${banner.link}"><img src="${banner.image}" alt=""></a>
                                            </div>`
                                    if (existingDiv) {
                                        existingDiv.insertAdjacentHTML('afterend', cardHTML)
                                    }
                                })
                                // boost-sd__product-item
                            }
                        },700)
                    } catch(error) {
                        console.warn(error);
                    }
                }
            })
        })
    }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize_inline_banner.productListAfterRender]);